import { add, subtract, multiply, divide, merge, isNil } from 'ramda';
import { fromJS } from 'immutable';
import roundTo from 'round-to';
import {
  roundToNearest,
  roundUpToNearest,
  roundDownToNearest,
} from '../../../utils/rounding-helpers';

const roundNumber = ({ roundType, cents }, num) => {
  const newNum = Number(num);
  if (roundType === 'alwaysUp') return roundUpToNearest(newNum, cents);
  if (roundType === 'alwaysDown') return roundDownToNearest(newNum, cents);
  return roundToNearest(newNum, cents);
};
const calRatesWithNewCommission = (commission, { notApplyToExtraChild, roundingSetting }, rates) => {
  if (!rates) return rates;
  return rates.map(rate => {
    if (rate.get('notApplicable')) return rate;
    const initialNettRate = isNil(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
      (isNil(rate.get('nettRate')) ? 0 : rate.get('nettRate')) : // if no nettRate then 0 else nettRate
      rate.get('initialNettRate');
    const nettRate = multiply(rate.get('retailRate'))(100 - commission)/100;
    // console.log('calRatesWithNewCommission', { nettRate, commission });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
    return rate.merge(fromJS({
      initialNettRate,
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2),
    }));
  });
};

const calRatesWithNewRetailDiff = (retailDiff, commissionPercentage, { retailNettMeasure, notApplyToExtraChild, roundingSetting }, rates) => {
  if (!rates) return rates;
  return rates.map(rate => {
    if (rate.get('notApplicable')) return rate;
    const initialRetailRate = isNil(rate.get('initialRetailRate')) ? // Check isNil because rate may be 0
      (isNil(rate.get('retailRate')) ? 0 : rate.get('retailRate')) : // if no retailRate then 0 else retailRate
      rate.get('initialRetailRate');
    const initialNettRate = isNil(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
      (isNil(rate.get('nettRate')) ? 0 : rate.get('nettRate')) : // if no nettRate then 0 else nettRate
      rate.get('initialNettRate');
    const numberedRetailChange = Number(retailDiff);
    const retailDiffAmount = retailNettMeasure === 'percentage' ? multiply(initialRetailRate, divide(numberedRetailChange, 100)) : numberedRetailChange;
    const retailRate = add(initialRetailRate, retailDiffAmount);
    const nettRate = multiply(retailRate, subtract(100, commissionPercentage)) / 100;
    // console.log('calRatesWithNewRetailDiff', { retailDiffAmount, retailNettMeasure });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.merge(fromJS({ nettRate: initialNettRate, retailRate: initialRetailRate }));
    return rate.merge(fromJS({
      initialRetailRate,
      initialNettRate,
      retailRate: roundNumber(roundingSetting, retailRate).toFixed(2),
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2),
    }));
  });
};

export const updateRateSetsOrExtrasOrOffers = ({ updatedCommission, retailDiff }, settings, rateSetsOrExtrasOrOffers) => {
  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(rateSet => {
    const initialCommissionPercentage = Number(rateSet.get('initialCommissionPercentage')
      ? rateSet.get('initialCommissionPercentage')
      : rateSet.get('commissionPercentage'));
    const commissionPercentage = !updatedCommission ? initialCommissionPercentage : Number(updatedCommission);
    // console.log({ updatedCommission, retailDiff });
    // if nothing changed, use initial rate
    if (!updatedCommission && !retailDiff) {
      return rateSet.set('commissionPercentage', commissionPercentage)
        .set('retailDiff', retailDiff)
        .update('rates', rates => rates.map(rate => {
          if (rate.get('notApplicable')) return rate;
          return rate.merge(fromJS({
            // when user toggling settings without any number updated, intial values weren't there yet
            retailRate: rate.get('initialRetailRate') || rate.get('retailRate'),
            nettRate: rate.get('initialNettRate') || rate.get('nettRate'),
          }));
        }));
    }
    const ratesAfterCommission = commissionPercentage && !isNaN(commissionPercentage)
      ? calRatesWithNewCommission(Number(commissionPercentage), settings, rateSet.get('rates'))
      : rateSet.get('rates');
    const ratesAfterRetailDiff = !isNil(retailDiff) && !isNaN(retailDiff)
      ? calRatesWithNewRetailDiff(retailDiff, commissionPercentage, settings, ratesAfterCommission)
      : ratesAfterCommission;
    const updateObject = {
      initialCommissionPercentage,
      rates: ratesAfterRetailDiff,
      commissionPercentage,
    };
    return rateSet.merge(fromJS(updateObject));
  });
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/update-commission-rates.js